import React from "react";
import PrayerButtonGrid from "../components/PrayerButtonGrid";
import { Container, Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";


const categories = [
  "wisdom_prayer",
  "peace_prayer",
  "patience_prayer",
  "gratitude_prayer",
  "faith_prayer",
  "forgiveness_prayer",
  "guidance_prayer",
  "strength_prayer",
  "boyfriend",
  "girlfriend",
  "purpose_prayers",
  "anxiety_prayers",
  "dog_prayer",
  "cat_prayer"
];

const labels = {
  wisdom_prayer: "Sabiduría",
  peace_prayer: "Paz",
  patience_prayer: "Paciencia",
  gratitude_prayer: "Gratitud",
  faith_prayer: "Fe",
  forgiveness_prayer: "Perdón",
  guidance_prayer: "Guía",
  strength_prayer: "Fuerza",
  boyfriend: "Novio",
  girlfriend: "Novia",
  purpose_prayers: "Propósito",
  anxiety_prayers: "Ansiedad",
  dog_prayer: "Perro",
  cat_prayer: "Gato"
};

function SpanishMorePage() {
  const navigate = useNavigate();

  return (
    <Container className="mt-4">
      <h1 className="text-center mb-4">Más Oraciones</h1>
      <PrayerButtonGrid
        categories={categories}
        labels={labels}
        onSelect={(cat) =>
          navigate(`/es/prayer/${cat}`, { state: { from: "/es/more" } })
        }
      />
      <div className="text-center mt-4">
        <Button className="glass-button bg-transparent border-0" onClick={() => navigate("/es")}>
          Volver al Inicio
        </Button>
      </div>
    </Container>
  );
}

export default SpanishMorePage;

